import styled from 'styled-components'
import { color } from '../../../../GlobalStyle'

export const Button = styled.button`
  position: relative;
  color: ${color.brand};
  border: 1px solid ${color.brand};
  border: 1px solid ${(props) => props.color};
  color: ${(props) => props.color};

  width: 2rem;
  height: 2rem;
  display: flex;
  justify-content: center;
  border-radius: 360px;
  margin-left: 0.3rem;
  align-items: center;
  font-size: 15px;
`
